module.exports = __webpack_public_path__ + "static/img/bg-home-hero.a8f10edf.jpg";